import React from 'react';
import { FaHeart, FaSmile, FaRegClock, FaChild, FaLightbulb, FaHandshake, FaRegGrinStars } from 'react-icons/fa';
import { IoMdSchool } from 'react-icons/io';


// Componente para os Cards de Tipo de Apoio
const SupportCard = ({ icon: Icon, title, description }) => (
  <div className="bg-white p-6 rounded-xl shadow-lg border-t-4 border-primary flex flex-col items-start h-full">
    <Icon className="text-primary w-8 h-8 mb-4 flex-shrink-0" />
    <h3 className="text-xl font-bold text-primary mb-2">{title}</h3>
    <p className="text-gray-700 text-sm leading-relaxed">{description}</p>
  </div>
);

const ProgramDetailItem = ({ title, description }) => (
  <div className="mb-2">
    <span className="font-semibold">{title}:</span>{' '}
    <span className="text-sm">{description}</span>
  </div>
);


function CriancasAtipicas() {

  return (
    // Container Principal - Define a fonte, etc.
    <div className="min-h-screen lg:pt-20 bg-gray-50">

      {/* Seção 1: Cabeçalho (Verde Água) */}
      <header className={`bg-primary pt-10 pb-20 px-4 md:px-8 text-white text-center`}>
        <div className="max-w-4xl mx-auto">
          
          {/* Logo/Smile customizado */}
          <div className="mb-6">
            {/* Smile Artístico - Simulando o desenho da imagem */}
            <div className="inline-block relative">
                <FaSmile className={`w-24 h-24 text-third`} />

            </div>
          </div>

          <h1 className="text-4xl md:text-5xl font-extrabold mb-2">
            Crianças Atípicas
          </h1>
          <p className="text-lg md:text-xl px-4">
            Apoio ao desenvolvimento e inclusão de crianças com necessidades especiais.
          </p>
        </div>
      </header>

      {/* Seção Principal de Conteúdo */}
      <main className="max-w-6xl mx-auto -mt-12 px-4 md:px-8">
        
        {/* Bloco de Informações - Sobre o Programa (Divisão em 2 colunas) */}
        <div className="grid md:grid-cols-2 gap-6 mb-12">

          {/* Coluna 1: Sobre o Programa - Texto Longo (Fundo Branco na imagem, mas colocarei um card) */}
          <div className={`bg-white p-8 rounded-xl shadow-lg border-t-4 border-primary`}>
            <h2 className={`text-2xl font-bold text-third mb-4`}>
              Sobre o Programa
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              O programa Crianças Atípicas oferece apoio ao desenvolvimento de crianças com necessidades especiais através de atividades lúdicas, educativas e terapêuticas.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Nossos voluntários trabalham em parceria com profissionais para proporcionar um ambiente seguro, acolhedor e estimulador para cada criança.
            </p>
          </div>

          {/* Coluna 2: Sobre o Programa - Detalhes (Fundo Azul Marinho) */}
          <div className={`bg-third p-8 rounded-xl shadow-lg text-white`}>
            <h2 className="text-2xl font-bold mb-4">
              Sobre o Programa
            </h2>
            <ProgramDetailItem
              title="Frequência"
              description="Agendada (flexível conforme necessidade)"
            />
            <ProgramDetailItem
              title="Duração"
              description="1-2 horas por sessão"
            />
            <ProgramDetailItem
              title="Faixa Etária"
              description="3-17 anos"
            />
            <ProgramDetailItem
              title="Localização"
              description="Centros de desenvolvimento especializados"
            />
          </div>

        </div>

        {/* Seção 2: Tipos de Apoio (3 Cards) */}
        <section className="py-8">
          <h2 className={`text-3xl font-bold text-third mb-8 text-center`}>
            Tipos de Apoio
          </h2>
          <div className="grid md:grid-cols-3 gap-6">

            <SupportCard
              icon={FaChild} // Ícone Lúdico/Brincadeira
              title="Atividades Lúdicas"
              description="Brincadeiras estruturadas que estimulam o desenvolvimento motor, cognitivo e social."
            />

            <SupportCard
              icon={IoMdSchool} // Ícone Educativo/Escola
              title="Apoio Educativo"
              description="Atividades que complementam o aprendizado escolar de forma inclusiva e adaptada."
            />

            <SupportCard
              icon={FaHandshake} // Ícone Social/Interação
              title="Acompanhamento Social"
              description="Momentos de interação que promovem inclusão, amizade e bem-estar emocional."
            />

          </div>
        </section>

        {/* Seção 3: Perfil dos Voluntários (Fundo Azul Marinho) */}
        <section className={`bg-third p-8 rounded-xl shadow-2xl mt-12 mb-12 text-white`}>
          <h2 className="text-3xl font-bold mb-6 text-center">
            Perfil dos Voluntários
          </h2>
          <div className="grid md:grid-cols-2 gap-4 text-lg">
            
            <ul className="list-none space-y-2">
              <li className="flex items-center">
                <FaRegGrinStars className={`w-5 h-5 mr-3 text-fourth flex-shrink-0`} />
                Disposição para trabalhar com crianças com necessidades especiais
              </li>
              <li className="flex items-center">
                <FaLightbulb className={`w-5 h-5 mr-3 text-fourth flex-shrink-0`} />
                Criatividade e dinamismo
              </li>
            </ul>

            <ul className="list-none space-y-2">
              <li className="flex items-center">
                <FaHeart className={`w-5 h-5 mr-3 text-fourth flex-shrink-0`} />
                Paciência e empatia
              </li>
              <li className="flex items-center">
                <FaRegClock className={`w-5 h-5 mr-3 text-fourth flex-shrink-0`} />
                Disponibilidade flexível
              </li>
            </ul>

          </div>
        </section>

      </main>
      
      {/* Seção 4: CTA (Call to Action) */}
      <div className="text-center py-10 bg-gray-50">
        <p className={`text-2xl font-semibold text-third mb-6`}>
          Pronto para se voluntariar?
        </p>
        <button
          className={`bg-fourth hover:bg-opacity-80 text-white font-bold py-3 px-8 rounded-full text-lg shadow-xl transition duration-300 ease-in-out transform hover:scale-105`}
          onClick={() => alert('Direcionando para a página de inscrição...')}
        >
          Inscreva-se
        </button>
      </div>

    </div>
  );
};

export default CriancasAtipicas;